/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Popup from 'components/Popup';
import { Avatar, Button } from 'xland-ui';
import InputFileZone from 'components/Inputs/inputFileZone';
import { uploadFile } from 'modules/actions';
import IOFileLoading from 'components/IOFileLoading/components';

function PopupEmailAssets({ assets, onClose, onSubmit }) {
  const [valuatLogo, setValuatLogo] = useState(assets.valuatLogo);
  const [linkedinLogo, setLinkedinLogo] = useState(assets.linkedinLogo);
  const [euLogo, setEuLogo] = useState(assets.euLogo);
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [uploadError, setUploadError] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    await onSubmit({ valuatLogo, linkedinLogo, euLogo });
  };

  const handleChange = async (file, type) => {
    setUploading(type);
    if (uploadError) {
      setUploadError(false);
    }

    try {
      const fileInfo = await uploadFile(file, false);
      switch (type) {
        case 'valuat':
          setValuatLogo(fileInfo);
          break;
        case 'linkedin':
          setLinkedinLogo(fileInfo);
          break;
        case 'eu':
          setEuLogo(fileInfo);
          break;
        default:
          break;
      }
    } catch (errors) {
      setUploadError(errors);
    }
    setUploading(false);
  };

  return (
    <Popup title='Editar Assets' onClose={onClose} size='md'>
      <form onSubmit={handleSubmit}>
        <div className='d-flex align-items-end gap-4 mb-4'>
          <Avatar src={uploading === 'valuat' ? null : valuatLogo?.path} size={50} className='mb-1' />
          <InputFileZone
            id='valuat-logo'
            className='input-asset-email'
            preText='Logo Valuat'
            accept='image/*'
            value={valuatLogo}
            onChange={file => handleChange(file, 'valuat')}
            isDisabled={uploading}
          />
        </div>
        <div className='d-flex align-items-end gap-4 mb-4'>
          <Avatar src={uploading === 'linkedin' ? null : linkedinLogo?.path} size={50} className='mb-1' />
          <InputFileZone
            id='linkedin-logo'
            className='input-asset-email'
            preText='Logo de LinkedIn'
            accept='image/*'
            value={linkedinLogo}
            onChange={file => handleChange(file, 'linkedin')}
            isDisabled={uploading}
          />
        </div>
        <div className='d-flex align-items-end gap-4 mb-4'>
          <Avatar src={uploading === 'eu' ? null : euLogo?.path} size={50} className='mb-1' />
          <InputFileZone
            id='eu-logo'
            className='input-asset-email'
            preText='Logo de EU'
            accept='image/*'
            value={euLogo}
            onChange={file => handleChange(file, 'eu')}
            isDisabled={uploading}
          />
        </div>
        <div className='buttons'>
          <Button
            text='Guardar'
            type='submit'
            loading={loading}
            disabled={uploading || !valuatLogo || !linkedinLogo || !euLogo}
          />
        </div>
        {uploading && <IOFileLoading file={uploading} />}
      </form>
    </Popup>
  );
}

PopupEmailAssets.propTypes = {
  assets: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default PopupEmailAssets;
